import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import { ensurePanelAdminSession } from "../utils/panelSession";

function getAdminContext() {
  try {
    const raw = JSON.parse(localStorage.getItem("employee") || "{}");
    return {
      docId: String(raw?.docId || ""),
      role: String(raw?.role || ""),
      mobile: String(raw?.mobile || ""),
    };
  } catch {
    return { docId: "", role: "", mobile: "" };
  }
}

async function callCrmFunction(name, payload = {}) {
  const { employee } = await ensurePanelAdminSession({ forceRefresh: true });
  const app = getApp();
  const functions = getFunctions(app, "asia-south1");
  const fn = httpsCallable(functions, name);
  const res = await fn({
    ...payload,
    adminContext: {
      ...getAdminContext(),
      docId: String(employee?.docId || ""),
      role: String(employee?.role || ""),
      mobile: String(employee?.mobile || ""),
    },
  });
  return res?.data || {};
}

export async function sendCrmWhatsappBroadcast(payload) {
  return callCrmFunction("sendCrmWhatsappBroadcast", payload);
}

export async function sendInviteAppUsersWhatsapp(users = [], options = {}) {
  return callCrmFunction("sendInviteAppUsersWhatsapp", {
    users,
    dryRun: Boolean(options.dryRun),
  });
}
